export enum ToolTipHolderOptions {
  visible,
  hidden,
}

export const DEFAULT_TITLE = '';
